import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme }) => ({
    '& .statement': {
        paddingTop: toRem(16),
        borderTop: `2px solid ${theme.colors.goldDark}`,
        fontSize: toRem(11),
        fontStyle: 'italic',

        [theme.breakpoints.up('lg')]: {
            marginTop: toRem(180)
        },

        [theme.breakpoints.up('xl')]: {
            marginTop: toRem(270)
        }
    }
})

export default style
